import { Optional, SystemSettingsTemplate } from '../../../types/common';
import { EffectorData } from '../../../types/systems';

export const effectorsSettingsTemplate: SystemSettingsTemplate<EffectorData> = {
	sections: {
		'': {
			expl_radius: { type: 'slider', max_limit: 100, step: 5, unit: 'm' },
		},
		Marks: {
			reload_time: {
				type: 'slider',
				max_limit: 600,
				step: 1,
				unit: 's',
			},
			fire_type: {
				type: 'select',
				data: [
					{ value: 'DIRECT', label: 'DIRECT' },
					{ value: 'INDIRECT', label: 'INDIRECT' },
					{ value: 'STORAGE', label: 'STORAGE' },
				],
			},
			round_weight: {
				type: 'dynamic-unit-input',
				label: 'Round Weight',
				step: 1,
				precision: 2,
				max_limit: 15000,
				min_limit: 0,
				unitType: 'weight',
				unit: 'kg',
			},
		},
		'Hit probabilities': {
			phit_distances: {
				type: 'table',
				columns: { dshort: 'Short', dmedium: 'Medium', dlong: 'Long' },
				use_archetypes: false,
				editable: true,
				value_type: 'string',
				conditionalRenderProperty: 'fire_type',
				conditionalRenderValues: ['DIRECT', 'INDIRECT'],
			},
			phit_probabilities: {
				type: 'table',
				columns: {
					target: 'Ranges to (m)',
					dshort: 'Short',
					dmedium: 'Medium',
					dlong: 'Long',
				},
				use_archetypes: true,
				editable: true,
				value_type: 'string',
				conditionalRenderProperty: 'fire_type',
				conditionalRenderValues: ['DIRECT', 'INDIRECT'],
			},
		},
		'Kill probabilities': {
			pkill: {
				type: 'table',
				columns: {
					target: 'Armor',
					none: 'None',
					active: 'Active',
					passive: 'Passive',
					reactive: 'Reactive',
				},
				use_archetypes: true,
				editable: true,
				value_type: 'string',
				conditionalRenderProperty: 'fire_type',
				conditionalRenderValues: ['DIRECT', 'INDIRECT'],
			},
		},
		Effector: {
			side: {
				type: 'select',
				data: [
					{ value: '2', label: 'NONE' },
					{ value: '0', label: 'BLUE' },
					{ value: '1', label: 'RED' },
				],
			},
			cost: 'text',
			name: 'text',
		},
	},
};

export const defaultSettings: Optional<EffectorData, 'id'> = {
	name: 'New effector',
	side: 0,
	cost: '0',
	expl_radius: 0,
	indirect_fire: false,
	fire_type: 'DIRECT',
	reload_time: 0,
	round_weight: 0.0,
	phit_distances: {
		dlong: '0',
		dmedium: '0',
		dshort: '0',
	},
	phit_probabilities: [
		{
			target: 11,
			dshort: '0.00',
			dmedium: '0.00',
			dlong: '0.00',
		},
		{
			target: 1,
			dshort: '0.00',
			dmedium: '0.00',
			dlong: '0.00',
		},
		{
			target: 2,
			dshort: '0.00',
			dmedium: '0.00',
			dlong: '0.00',
		},
		{
			target: 3,
			dshort: '0.00',
			dmedium: '0.00',
			dlong: '0.00',
		},
		{
			target: 4,
			dshort: '0.00',
			dmedium: '0.00',
			dlong: '0.00',
		},
		{
			target: 5,
			dshort: '0.00',
			dmedium: '0.00',
			dlong: '0.00',
		},
		{
			target: 9,
			dshort: '0.00',
			dmedium: '0.00',
			dlong: '0.00',
		},
		{
			target: 7,
			dshort: '0.00',
			dmedium: '0.00',
			dlong: '0.00',
		},
		{
			target: 6,
			dshort: '0.00',
			dmedium: '0.00',
			dlong: '0.00',
		},
		{
			target: 12,
			dshort: '0.00',
			dmedium: '0.00',
			dlong: '0.00',
		},
		{
			target: 10,
			dshort: '0.00',
			dmedium: '0.00',
			dlong: '0.00',
		},
		{
			target: 8,
			dshort: '0.00',
			dmedium: '0.00',
			dlong: '0.00',
		},
	],
	pkill: [
		{
			target: 11,
			none: '0.00',
			active: '0.00',
			passive: '0.00',
			reactive: '0.00',
		},
		{
			target: 1,
			none: '0.00',
			active: '0.00',
			passive: '0.00',
			reactive: '0.00',
		},
		{
			target: 2,
			none: '0.00',
			active: '0.00',
			passive: '0.00',
			reactive: '0.00',
		},
		{
			target: 3,
			none: '0.00',
			active: '0.00',
			passive: '0.00',
			reactive: '0.00',
		},
		{
			target: 4,
			none: '0.00',
			active: '0.00',
			passive: '0.00',
			reactive: '0.00',
		},
		{
			target: 5,
			none: '0.00',
			active: '0.00',
			passive: '0.00',
			reactive: '0.00',
		},
		{
			target: 9,
			none: '0.00',
			active: '0.00',
			passive: '0.00',
			reactive: '0.00',
		},
		{
			target: 7,
			none: '0.00',
			active: '0.00',
			passive: '0.00',
			reactive: '0.00',
		},
		{
			target: 6,
			none: '0.00',
			active: '0.00',
			passive: '0.00',
			reactive: '0.00',
		},
		{
			target: 12,
			none: '0.00',
			active: '0.00',
			passive: '0.00',
			reactive: '0.00',
		},
		{
			target: 10,
			none: '0.00',
			active: '0.00',
			passive: '0.00',
			reactive: '0.00',
		},
		{
			target: 8,
			none: '0.00',
			active: '0.00',
			passive: '0.00',
			reactive: '0.00',
		},
	],
};
